import { buildContentstackImageUrl } from "@/lib/utils";

const GalleryAccolades = ({ accolades, visible = true }) => {
  if (!accolades?.length) return null;

  return (
    <div
      // duration-300 matches Swiper's default `speed` so this fades in step with the mobile crossfade instead of cutting instantly.
      aria-hidden={!visible}
      // Desktop stacks vertically to avoid the shipping tooltip, mobile uses a row.
      className={`absolute md:max-w-26 top-4 md:top-6 left-0 md:left-6 right-0 z-5 flex flex-row flex-wrap lg:flex-col lg:flex-nowrap justify-center lg:justify-center items-center gap-2.5 md:gap-4 pointer-events-none transition-opacity duration-300 ${visible ? "opacity-100" : "opacity-0"}`}
    >
      {accolades.map((accolade, index) => (
        // Plain <img> is intentional: buildContentstackImageUrl already provides resize/webp.
        /* eslint-disable-next-line @next/next/no-img-element */
        <img
          key={accolade.url || index}
          src={buildContentstackImageUrl(accolade.url, 260)}
          alt={accolade.alt}
          width={accolade.width}
          height={accolade.height}
          // BL-937: the vertical stack of badges is taller than the hero image
          // between lg and xl (the fixed lg-bucket image is only ~372px tall),
          // so badges shrink here and return to full size at xl.
          className="h-13.5 md:h-22.5 lg:h-16 xl:h-22.5 w-auto object-contain"
        />
      ))}
    </div>
  );
};

export default GalleryAccolades;
